/**
 * @param props
 */
export default (props) => {
    return {
        input: null,
        source: props.source,
        label: props.label,
        focused: false,
        name: '',
        mounted() {
            this.complete[this.label] = {
                results: [],
                counter: 0,
                text: null,
            }
            this.input = this.$refs.input;
            this.source = window.variables.complete[this.label];
            this.source = this.source + (this.source.includes("?") ? '&' : '?') + this.input.name + '=';


            let typing = 0;
            let blurring = 0;
            let active = -1;
            let indexes = [];

            if (!this.input.dataset.hasOwnProperty('persist')) {
                this.input.addEventListener('focus', () => {
                    this.focused = true;
                    window.clearTimeout(blurring);
                }, { ive: true });

                this.input.addEventListener('blur', () => {
                    blurring = window.setTimeout ( () => {
                        this.focused = false;
                        this.reset();
                    },  250 );
                }, { ive: true });
            }

            this.input.addEventListener('keyup', (e) => {

                e.stopPropagation();

                switch ( e.key) {
                    case 'Escape':
                        window.clearTimeout(typing);
                        this.reset();
                        this.input.blur();
                        this.input.value = '';
                        break;
                    case 'Enter':
                        //this.reset();
                        this.input.blur();
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        active = ( 0 < active ) ? active - 1 : active;
                        this.complete[this.label].text = indexes[active];
                        this.input.value = indexes[active];
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        active = (active < this.complete[this.label].counter - 1 ) ? active + 1 : active;
                        this.complete[this.label].text = indexes[active];
                        this.input.value = indexes[active];
                        break;

                    default:

                        this.complete[this.label].text = this.input.value;

                        window.clearTimeout(blurring);
                        window.clearTimeout(typing);

                        if ( 2 <= this.input.value.length) {

                            typing = window.setTimeout(() => {

                                fetch(this.source + this.input.value).then((responses) => {
                                    return responses.json();
                                }).then((json) => {
                                    this.complete[this.label].results = json.results;
                                    this.complete[this.label].counter = json.counter;

                                    if (json.counter) {
                                        Object.values(json.results).forEach((group) => {
                                            Object.values(group.items).forEach((item) => {
                                                indexes.push(item.text);
                                            });
                                        });
                                        active = -1;
                                    }

                                });
                            }, 250);
                        } else {
                            this.reset();
                        }
                        break;
                }
            }, {ive: true});
        },
        reset() {
            setTimeout(() => {
                this.complete[this.label].results = [];
            }, 100);
            this.complete[this.label].counter = 0;
        }

    }
};
